import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { VerificarSesionService } from "@services/verificar-sesion.service";
import { SessionCaducadaService } from "@services/session-caducada.service";
import { SessionService } from "@services/session.service";
import { environment } from "@env/environment";

/**
 * En cada POST verifica asíncronamente si la sesión sigue activa en el backend.
 * Si no lo está, marca la sesión como caducada para que la UI bloquee la pantalla.
 * También intercepta respuestas 401 que indiquen sesión inválida/expirada.
 */
@Injectable()
export class SessionVerificarInterceptor implements HttpInterceptor {
    private verificacionEnVuelo = false;

    constructor(
        private verificarSesionService: VerificarSesionService,
        private sessionCaducadaService: SessionCaducadaService,
        private sessionService: SessionService
    ) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (req.method === "POST" && this.debeVerificar(req.url)) {
            this.verificacionEnVuelo = true;
            this.verificarSesionService.verificarSesion().subscribe({
                next: (activa) => {
                    if (!activa) {
                        this.sessionCaducadaService.marcarCaducada();
                    }
                },
                error: () => {},
                complete: () => {
                    this.verificacionEnVuelo = false;
                },
            });
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (this.esSesionExpirada(error)) {
                    this.sessionCaducadaService.marcarCaducada();
                }
                return throwError(() => error);
            })
        );
    }

    private esSesionExpirada(error: HttpErrorResponse): boolean {
        if (error.status !== 401) return false;
        if (this.sessionCaducadaService.caducada) return false;
        if (!this.sessionService.isAuthenticated()) return false;
        const msg: string = error.error?.error || error.error?.message || "";
        return msg.toLowerCase().includes("ses");
    }

    private debeVerificar(url: string): boolean {
        if (this.verificacionEnVuelo) return false;
        if (this.sessionCaducadaService.caducada) return false;
        if (!this.sessionService.isAuthenticated()) return false;
        if (url.includes(environment.verificarSesion)) return false;
        return true;
    }
}
